import { render, staticRenderFns } from "./TableAvenantArticlev2.vue?vue&type=template&id=11ecbcfd&scoped=true&"
import script from "./TableAvenantArticlev2.vue?vue&type=script&lang=js&"
export * from "./TableAvenantArticlev2.vue?vue&type=script&lang=js&"
import style0 from "./TableAvenantArticlev2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableAvenantArticlev2.vue?vue&type=style&index=1&id=11ecbcfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ecbcfd",
  null
  
)

export default component.exports